<div
  [libBodyCssClassAppend]="appendTo"
  [targetCssClass]="'appended-to-body'"
  class="form-group position-relative {{ cssClass }}"
  *ngIf="control"
>
  <label *ngIf="label" class="col-form-label">
    {{ label }}<span *ngIf="isRequired" class="text-danger"> *</span>
  </label>
  <ng-select
    [formControl]="control"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [class.is-invalid]="control.touched && !control.valid && !control.disabled"
    [clearable]="clearable"
    [closeOnSelect]="closeOnSelect"
    [items]="items"
    [placeholder]="placeholder"
    [readonly]="readonly"
    [multiple]="multiple"
    [searchable]="searchable"
    [dropdownPosition]="dropdownPosition"
    [appendTo]="appendTo"
    (change)="onChangeHandler($event)"
  >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <span class="ng-value-label">{{ !!bindLabel ? item[bindLabel] : item }}</span>
      <!-- v15 compatibility -->
      <!-- @let itemLocked = isItemLocked(item); -->
      <span
        class="ng-value-icon right"
        aria-hidden="true"
        [class.locked-item]="isItemLocked(item)"
        (click)="!isItemLocked(item) && clear(item)"
      >
        <img *ngIf="!isItemLocked(item)" alt="" src="assets/images/close.svg" width="16" height="16" />
        <i *ngIf="isItemLocked(item)" class="fas fa-lock"></i>
      </span>
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
      <!-- v15 compatibility -->
      <!-- @let itemLocked = isItemLocked(item); -->
      <span [class.locked-item]="isItemLocked(item)" [class.highlighted-option]="item[bindHighlighted]">
        {{ !!this.bindLabel ? item[this.bindLabel] : item }}
        <i *ngIf="isItemLocked(item)" class="ms-1 fas fa-lock"></i>
      </span>
    </ng-template>
  </ng-select>
  <app-form-field-error *ngIf="control.touched && !control.valid" [errors]="control.errors"></app-form-field-error>
</div>
